import React from 'react';
import Avatar from './AvatarUser';
import styled from 'styled-components';
import { setColor, setFont, setBoxShadow } from '../../styles/styles';

function ChatMessage({ className, message }) {
  //console.log(message.timestamp)
  return (
    <div className={className}>
      <div className="ChatMessages">
        {/*{console.log(message)}*/}
        <Avatar
          firstname={
            message.screen_name
              ? message.screen_name.toUpperCase()
              : message.author.toUpperCase()
          }
          is_attendant={message.is_attendant}
        />
        <div className="ChatMessage">
          {' '}
          <p className="ChatMessage_author">
            {message.screen_name ? message.screen_name : message.author}
            <span className="ChatMessage_time">
              {message.timestamp &&
                `${new Date(message.timestamp.replace(/ /g,"T")).getHours()}:${
                  new Date(message.timestamp.replace(/ /g,"T")).getMinutes() > 9
                    ? new Date(message.timestamp.replace(/ /g,"T")).getMinutes()
                    : '0' + new Date(message.timestamp.replace(/ /g,"T")).getMinutes()
                }`}
            </span>
          </p>
          <div>
            <p className="ChatMessage_content">{message.content}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default styled(ChatMessage)`
  .ChatMessages {
    display: flex;
    margin-bottom: -20px;

    margin-left: -10px;
    text-align: left;
    letter-spacing: 0px;
    width: 100%;
    overflow-wrap: anywhere;

    .MuiAvatar-colorDefault {
      background-color: firebrick !important;
      font-weight: bold;
      font-size: 20px;
      border-radius: 50%;
    }
  }
  .ChatMessage {
    margin-left: 4px;
    padding-right: 41px;
    color: black;
    border-radius: 10px;
    .ChatMessage_time {
      font-size: 1rem;
      color: #949393;
      margin-left: 5px;
    }
    .ChatMessage_author {
      text-transform: capitalize;
      font-weight: bolder;
      font-size: 1.2rem;
      font-family: ${setFont.lato};
      text-transform: capitalize;
      height: unset;
    }
    .ChatMessage_content {
      font-size: 1.2rem;
      font-weight: 500;
      font-family: arial;
      padding-bottom: 30px;
    }
  }
`;
